import { useState, useCallback } from 'react';

// Usage: const { confirm, ConfirmDialog } = useConfirm()
// await confirm('Er du sikker?') returns true/false

export function useConfirm() {
  const [state, setState] = useState(null); // { message, resolve }

  const confirm = useCallback((message) => {
    return new Promise((resolve) => {
      setState({ message, resolve });
    });
  }, []);

  const handle = (result) => {
    if (state) state.resolve(result);
    setState(null);
  };

  const ConfirmDialog = state ? (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-6 bg-black/60">
      <div className="bg-slate-700 rounded-2xl p-5 w-full max-w-xs shadow-2xl">
        <p className="text-white text-base leading-snug mb-5">{state.message}</p>
        <div className="flex gap-3">
          <button
            onClick={() => handle(false)}
            className="flex-1 py-3 rounded-xl bg-slate-600 text-white font-medium active:bg-slate-500">
            Annuller
          </button>
          <button
            onClick={() => handle(true)}
            className="flex-1 py-3 rounded-xl bg-red-600 text-white font-semibold active:bg-red-700">
            OK
          </button>
        </div>
      </div>
    </div>
  ) : null;

  return { confirm, ConfirmDialog };
}
